import React from 'react';

const ML_Data = () => {
    return (
        <div>ML_Data Component</div>
    );
}

export default ML_Data;
